import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import TableFunctions from "./ui/TreatmentTypeListFunctions";
import { strings } from "../resources";

class TableComponent extends React.Component {
  getTdProps = (state, rowInfo, column, instance) => {
    if (column) {
      return {
        onClick: () => {
          if (rowInfo) {
            this.props.history.push("/treatmentTypes/" + rowInfo.original.id);
          }
        }
      };
    }
    return {}; // getTdProps requires a return statement
  };

  render = () => {
    let data = this.props.treatmentTypeListData;

    const cellTruncate = length => {
      return row => {
        let value = row.value ? row.value : "";
        let truncatedValue =
          value.length > length ? (
            <div>{value.substring(0, length)}...</div>
          ) : (
            <div>{value}</div>
          );
        return truncatedValue;
      };
    };

    return (
      <div>
        <TableFunctions
          headers={this.props.headers}
          history={this.props.history}
        />
        <div>
          <ReactTable
            data={data}
            columns={[
              {
                Header: strings.table.header.treatmentType,
                accessor: "treatment_type",
                headerStyle: { textAlign: "left" },
                Cell: cellTruncate(20)
              },
              {
                Header: strings.table.header.treatmentCategory,
                accessor: "treatment_category",
                headerStyle: { textAlign: "left" },
                Cell: cellTruncate(20)
              },
              {
                Header: strings.table.header.periodUntilNextTreatment,
                accessor: "combined_time_until_next_treatment",
                headerStyle: { textAlign: "left" },
                Cell: cellTruncate(20)
              },
              {
                Header: strings.table.header.createdDate,
                accessor: "created_date_formatted",
                headerStyle: { textAlign: "left" },
                Cell: cellTruncate(20)
              }
            ]}
            className="-striped -highlight"
            defaultPageSize={10}
            minRows="1"
            getTdProps={this.getTdProps}
            getTrProps={this.getTrProps}
            noDataText="No results found."
            pageSizeOptions={[10, 20, 30]}
          />
        </div>
      </div>
    );
  };
}

TableComponent.propTypes = {
  deleteModalOpen: PropTypes.bool.isRequired,
  handleModalConfirm: PropTypes.func.isRequired,
  treatmentTypeListData: PropTypes.array.isRequired,
  headers: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  toggleDeleteModal: PropTypes.func.isRequired
};

export default TableComponent;
